import { PureComponent } from 'react';
import { clean } from 'ContentComponents/components/cmv2/sanitize/sanitize';
import { configureSanitize } from 'ContentComponents/components/cmv2/sanitize/sanitizeConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const Sanitize = configureSanitize();
class SanitizedLabel extends PureComponent {
  render() {
    const {
      label,
      useStrict
    } = this.props;
    return /*#__PURE__*/_jsx("span", {
      dangerouslySetInnerHTML: {
        __html: useStrict ? clean(label, Sanitize.Config.STRICT) : clean(label)
      }
    });
  }
}
SanitizedLabel.defaultProps = {
  useStrict: false
};
export default SanitizedLabel;